var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer-links-link"}},[_c('a',{staticClass:"darkLink",attrs:{"href":_vm.link.Url}},[_vm._v(" "+_vm._s(_vm.link.Text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }